import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../ds2/components";
import {
  setUser,
  setToken,
  setSignUpNow,
  selectSignupNow,
} from "../../redux/features/appData";
import { setAxiosAuthToken } from "../../services/client";
import {
  apiCreateUserWithWorkspace,
  apiGetUserByEmail,
  apiLoginExt,
} from "../../api";
import { useAuth0 } from "@auth0/auth0-react";
import SignupWidget from "./SignupWidget";
import "./Signup.css";
import { useDispatch, useSelector } from "react-redux";
import config from "environment";
import { User } from "winslow-core";

const authURL = config.redirect.replace("signup", "login") + "?error=oauth";

const loginExt = async (userId: string) => {
  const result = await apiLoginExt(userId);
  if (!result) {
    return;
  }
};

const createNewUser = async (user: any) => {
  console.log("[root/createNewUser] user: ", user);

  const { given_name, family_name, picture, email } = user;

  const newUser = (await apiCreateUserWithWorkspace(
    given_name,
    family_name,
    email,
    picture,
    null
  )) as User;

  console.log("[root/createNewUser] new user: ", newUser);

  return newUser;
};

export default function Signup() {

  const [headerText, setHeaderText] = useState<any>({
    title: "Sign Up.",
    subtitle: "It's free to start",
  });

  const signUpNow = useSelector(selectSignupNow);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, getAccessTokenSilently, logout } = useAuth0();

  // useEffect(() => {
  //   const stashUrl = localStorage.getItem("stashUrl");
  //   localStorage.removeItem("stashUrl");
  //   if (stashUrl) {
  //     navigate(stashUrl);
  //     return;
  //   }
  // }, []);

  const redirectUser = () => {
    const stashUrl = localStorage.getItem("stashUrl");
    localStorage.removeItem("stashUrl");
    if (stashUrl) {
      navigate(stashUrl);
      return;
    }

    navigate("/waz/chat/");
  };

  useEffect(() => {
    (async () => {
      if (!user) {
        return;
      }

      const accessToken = await getAccessTokenSilently();

      dispatch(setToken(accessToken));
      setAxiosAuthToken(accessToken);

      // is this a new user, lets handle that now
      if (signUpNow === true) {
        // is this user already signed up and they just hit the wrong button
        const loadedUser = await apiGetUserByEmail(user.email);

        console.log("loadedUser", loadedUser);

        // if we don't have a user, create one
        if (!loadedUser) {
          (async () => {
            const newUser = await createNewUser(user);
            dispatch(setSignUpNow(false));
            if (newUser) {
              dispatch(setUser(newUser));
              loginExt(newUser.id);
              redirectUser();
              return;
            } else {
              // console.error("[root/useeffect] failed to create new user: ", user);
            }

            // something went wrong, bounce them out again
            console.error("[root/use effect] new user failed to create!");
          })();

          return;
        }

        // we have the user, so just log the user in below
        dispatch(setUser(loadedUser));
        loginExt(loadedUser.id);
        redirectUser();
        return;
      } else {
        const loadedUser = await apiGetUserByEmail(user.email);

        // if this user does not exist we need to bounce the user out as someone hit
        // login and picked a user that we don't have in the DB

        if (!loadedUser) {
          // need to clean up OAuth so the user can try again as this is likely
          // the reason they got here

          // cleanup auth
          logout({ logoutParams: { returnTo: authURL } });
          return;
        }
        loginExt(loadedUser.id);
        dispatch(setUser(loadedUser));

        redirectUser();
      }
    })();
  }, [user]);

  return (
    <div className={config.theme} style={{ width: "100%", height: "100%" }}>
      <div id="signup">
        <div className="signup-header">
          <div className="signup-header-logo">
            <img src="/logos/winslow_logo.svg" alt="" />
          </div>
          <div className="signup-header-buttons">
            Or&nbsp;
            <Button
              variant="secondary"
              size="sm"
              onClick={() => {
                navigate("/login");
              }}>
              Sign In
            </Button>
          </div>
        </div>
        <div className="signup-container">
          <div className="signup-title">
            <h1>
              {headerText.title}
              <br />
              {headerText.subtitle}
            </h1>
          </div>

          <SignupWidget />
        </div>
      </div>
    </div>
  );
}
